import script from "./BaseQwoachDialog.vue?vue&type=script&lang=js"
export * from "./BaseQwoachDialog.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__